import InspirationProductsList from "@/components/organisms/inspiration-products-list";
import { DialogClose } from "@/components/ui/dialog";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Locales } from "@/lib/i18n";
import { __ } from "@/lib/i18n/functions";
import { InspirationDocument, ProductDocument } from "@/prismicio-types";
import { XIcon } from "lucide-react";
import Image from "next/image";

type InspirationSingleWrapperProps = {
  locale: Locales;
  inspiration: InspirationDocument;
  products: ProductDocument[];
};

const InspirationSingleWrapper = ({ inspiration, locale, products }: InspirationSingleWrapperProps) => {
  const { title, featured_image } = inspiration.data;

  return (
    <section className="text-dark-primary p-5 md:px-6 md:py-6 xl:px-8">
      <div className="flex gap-5 max-lg:flex-col md:gap-3.5">
        <div className="w-full space-y-3.5 lg:max-w-[742px]">
          <div className="flex w-full items-start justify-between">
            <h1 className="font-cabinet-grotesk leading-h1 max-w-[742px] text-[26px] font-medium md:line-clamp-1 md:text-[35px] md:leading-[150%]">
              {inspiration.data.title}
            </h1>
            <DialogClose>
              <XIcon size={36} aria-hidden="true" className="text-dark-primary cursor-pointer lg:hidden" />
            </DialogClose>
          </div>
          <figure className="relative h-[300px] w-full overflow-hidden rounded-md lg:h-[542px] lg:max-w-[742px]">
            <Image src={featured_image.url || ""} alt={title || ""} fill className="object-cover" />
          </figure>
        </div>
        <div className="flex-1">
          <div className="flex w-full items-center justify-between">
            <h4 className="font-cabinet-grotesk mb-2 w-full text-2xl font-medium max-sm:mb-4.5 lg:mt-5">
              {__("Products Presents :", locale)}
            </h4>
            <DialogClose>
              <XIcon size={42} className="text-dark-primary cursor-pointer max-lg:hidden" />
            </DialogClose>
          </div>
          <ScrollArea className="relative h-[320px] w-full lg:h-[542px]">
            <InspirationProductsList products={products} locale={locale} />
          </ScrollArea>
        </div>
      </div>
    </section>
  );
};

export default InspirationSingleWrapper;
